// btw-front/src/api/adminPartners.js
import { api } from "./client";

// 파트너사 목록 — { id, companyName, businessNumber, status, canRegisterDeal,
//                  isDeleted, deletedAt, deletedByName, userCount, dealCount,
//                  pendingDealCount, deletedDealCount, createdAt }
// dealCount 는 심사를 통과한 '활성 딜' 만, 심사 중은 pendingDealCount 로 분리된다.
// 회사 삭제는 둘 다 지우므로 "함께 삭제되는 건수" 는 두 값의 합이다.
export async function list() {
  const res = await api.get("/admin/partners");
  return res.items || [];
}

// 신규 딜 등록 허용/제한 토글 — 제한(false) 시 그 회사의 딜 등록 요청이 403 으로 막힌다
export async function updateDealPermission(id, canRegisterDeal) {
  return api.put(`/admin/partners/${encodeURIComponent(id)}/deal-permission`, {
    canRegisterDeal,
  });
}

// 파트너사 소프트 삭제 — 행·파일은 그대로 두고 로그인을 막는다(복구 수단 없음).
// 함께 삭제되는 것:
//   - 그 회사가 등록한 딜 → [삭제된 딜] 탭에서만 열람된다
//   - 그 회사의 로그인 계정(partner_user.status='deleted') → 계정 상태를 회사와 맞춘다.
//     재가입은 같은 사업자등록번호로 가능하다(확인 대화에서 안내). 계정 이메일은 원래 중복을
//     허용하므로(로그인 ID 만 유일) 같은 담당자 이메일로도 다시 가입할 수 있다.
// 응답 { ok, alreadyDeleted, deletedDealCount, deletedUserCount } — 이미 삭제된 회사도 200(멱등).
//   deletedUserCount 는 화면에서 쓰지 않는다 — 삭제 전 확인창이 목록의 userCount 로 미리 알린다
//   (한 회사에 계정이 여러 개일 수 있다).
//   서버 로그와 대조하려고 응답에 싣는다 — 딜 건수와 나란히 두면 cascade 가 어디까지
//   돌았는지 한 번에 보인다.
export async function remove(id) {
  return api.del(`/admin/partners/${encodeURIComponent(id)}`);
}

// 딜 담당자 변경 셀렉트용 — 활성 파트너사의 영업대표·활성 계정.
// { salesReps: [{ id, name, title, phone, email, ownerUserId, ownerName, ownerLoginId, isOwnerActive }],
//   accounts: [{ id, name, loginId }] } — 삭제·정지 회사는 404.
export async function salesReps(id) {
  return api.get(`/admin/partners/${encodeURIComponent(id)}/sales-reps`);
}
